


































import {Component, Vue} from "vue-property-decorator";

@Component({
  name: "Login",
})
export default class Login extends Vue {
  // @auth.Action
  // updateToken!: (token: string) => void;
  // @auth.Action
  // updateExpiredAt!: (time: string) => void;
  // @auth.Action
  // updateRole!: (role: string) => void;
  // @auth.Action
  // fetchCurrentUser!: () => void;

  form = {
    email: "",
    password: "",
  };
  errorMessage = "";

  public login() {
    this.$router.push({name: 'menu'}).catch(error => { console.log(error)})
  }
}
